import { workLogos } from "../data/siteData";

export default function WorkLogos({ animated = false }) {
  if (animated) {
    return (
      <div className="work-logos is-animated">
        <div className="work-logos-group">
          {workLogos.map((logo, index) => (
            <img key={`${logo.alt}-${index}`} src={logo.src} alt={logo.alt} />
          ))}
        </div>
        <div className="work-logos-group" aria-hidden="true">
          {workLogos.map((logo, index) => (
            <img
              key={`${logo.alt}-duplicate-${index}`}
              src={logo.src}
              alt={logo.alt}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="work-logos">
      {workLogos.map((logo, index) => (
        <img key={`${logo.src}-${index}`} src={logo.src} alt={logo.alt} />
      ))}
    </div>
  );
}
